import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgAppleLogo = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  if (!props.noAlign) {
    const className = (props.className || "") + " " + styles.alignIcon;
    props = Object.assign({}, props, {
      className,
    });
  }
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g clipPath="url(#src__com__yext__listingslaunchstorm__public__icons__apple-logo_svg__a)">
        <path
          d="M12.853 4.92c1.127-1.484 2.692-1.491 2.692-1.491s.233 1.396-.886 2.74c-1.194 1.436-2.552 1.2-2.552 1.2s-.255-1.128.746-2.448Zm-.603 3.428c.58 0 1.655-.797 3.055-.797 2.409 0 3.357 1.715 3.357 1.715s-1.854.947-1.854 3.247c0 2.595 2.31 3.489 2.31 3.489s-1.615 4.544-3.795 4.544c-1.002 0-1.78-.675-2.836-.675-1.075 0-2.143.7-2.838.7-1.99 0-4.506-4.31-4.506-7.775 0-3.409 2.129-5.197 4.126-5.197 1.298 0 2.306.749 2.98.749Z"
          fill="#999"
        />
      </g>
      <defs>
        <clipPath id="src__com__yext__listingslaunchstorm__public__icons__apple-logo_svg__a">
          <path
            fill="#fff"
            transform="translate(5.143 3.429)"
            d="M0 0h13.975v17.143H0z"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export default SvgAppleLogo;
